import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const ShadowElement = styled.div`
  position: fixed;
  width: 1px;
  height: 1px;
  background: transparent;
  pointer-events: none;
  z-index: 9999;
  transform: translate(-50%, -50%);
  box-shadow: 
    0 0 60px 20px rgba(255, 255, 255, 0.1),
    0 0 120px 40px rgba(255, 255, 255, 0.06),
    0 0 180px 60px rgba(255, 255, 255, 0.03);
  filter: blur(1px);
`;

const MouseShadow = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <ShadowElement
      style={{
        left: position.x,
        top: position.y,
      }}
    />
  );
};

export default MouseShadow;